import React, { CSSProperties } from 'react'
import { ColorFormat, Color as ColorType } from '../../../../../../types'
import { Container, ColorIcon, Text } from './ColorDot.styles'
import { FormattedColorValue } from '../FormattedColorValue'

export interface ColorProps extends ColorType {
  style?: CSSProperties
  format?: ColorFormat
  $iconSize?: number
  dropFormat?: boolean
}

export const ColorDot: React.FCC<ColorProps> = ({
  red,
  green,
  blue,
  alpha = 1,
  format = ColorFormat.HEX,
  dropFormat = false,
}) => {
  return (
    <Container>
      <ColorIcon
        dropFormat={dropFormat}
        red={red}
        green={green}
        blue={blue}
        alpha={alpha}
      />
      <Text className="ColorText">
        <FormattedColorValue
          format={format}
          color={{ red, green, blue, alpha }}
        />
      </Text>
    </Container>
  )
}
